const TAGS = {
  ASSIGNMENT_UNIT: "AssignmentUnit",
  AUDIENCE_FILTER: "AudienceFilter",
  ISOLATION_GROUP: "IsolationGroup",
  /**
   * Tag to track the capacity used by an isolation group id. This lets us invalidate
   * the cache when an experiment on a given isolation group is executed on.
   */
  ISOLATION_GROUP_CAPACITY_OPERATION: "IsolationGroupCapacityOperation",
  FEATURE: "Feature",
  EXPERIMENT: "Experiment",
  EXPERIMENT_STEP: "ExperimentStep",
  EXPERIMENTATION_GROUP: "ExperimentationGroup",
  EXPERIMENTATION_GROUP_SETTINGS: "ExperimentationGroupSettings",
  PROGRESSION: "Progression",
  PROGRESSION_TEMPLATE: "ProgressionTemplate",
  GATE: "Gate",
  GATE_TYPE: "GateType",
  EXPERIMENT_OPERATION_SET: "ExperimentOperationSet",
  VARIANT: "Variant",
  VARIANT_COMPOSITION: "VariantComposition"
};
const URL_SEGMENTS = {
  FEATURE: "features",
  EXPERIMENT: "experiments",
  EXPERIMENTATION_GROUP: "experimentation-groups",
  EXPERIMENTATION_GROUP_SETTINGS: "experimentation-group-settings",
  EXPERIMENT_STEP: "experiment-steps",
  GATE: "gates",
  GATE_TYPE: "gate-types",
  VARIANT: "variants",
  PROGRESSION: "progressions",
  PROGRESSION_TEMPLATE: "progression-templates",
  ASSIGNMENT_UNIT: "assignment-units",
  AUDIENCE_FILTER: "audience-filters",
  ISOLATION_GROUP: "isolation-groups",
  EXPERIMENT_OPERATION_SET: "operation-sets"
};
export {
  TAGS,
  URL_SEGMENTS
};
//# sourceMappingURL=common.js.map
